import Button from '../../../components/SendButton'

import styles from './SendButton.module.scss'

interface Props {
    loading: boolean
    disabled: boolean
    toolTipText?: string
    buttonClassName?: string
}

const SendButton = ({ loading, disabled, toolTipText, buttonClassName }: Props) => {
    return (
        <Button
            loading={loading}
            className={styles.sendButton}
            buttonClassName={buttonClassName ?? styles.button}
            disabled={disabled}
            toolTipText={toolTipText}
        />
    )
}

export default SendButton
